module.exports = __webpack_public_path__ + "static/media/minus.933d122a.svg";